import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import useDidMountEffect from "../../customHooks/useDidMountEffect";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import CustomInput from "../../components/CustomInput/CustomInput";
import checkValidCellphoneCode from "../../utils/helpers/checkValidCellphoneCode";
import RadioButtons from "../../components/RadioButtons/RadioButtons";
import LoginInitialValues from "../../entities/LoginInitialValues";
import Otp, { suspensionTimeInMiliseconds } from "../../components/Otp/Otp";
import { OtpSend, otpSendUtil } from "../../services/OtpSend";
import { useDispatch, useSelector } from "react-redux";
import RenderInputError from "./RenderInputError/RenderInputError";
import CircleLoading from "../../components/CircleLoading/CircleLoading";
import { resetUser, setIsEnteredFromToShowFile, setIsSendAgainPossible, setIsSendAgainPossibleDate, setIssueDate, setIsSuspend, setIsValidAndNotUser, setUserId } from "../../state/actions/UserActions";
import { isEnterPress } from "../../utils/helpers/accessibilityUtil";
import { setActiveFund } from "../../state/actions/DashboardActions";
import UserFund from "../../entities/UserFund";
import useInputFocus from "../../customHooks/useInputFocus";
import '../../components/CustomInput/CustomInput.scss'
import "./Login.scss";
import { NavLink } from "react-router-dom";
import { screenSzie } from "../../utils/main";
import useWindowDimensions from "../../customHooks/useWindowDimensions";
import { deepLinkOTPSend, otpSendDeeplinkUtil } from "../../services/deepLinkOTPSend";
import { CheckDeeplinkValid, deeplink } from "../../services/CheckDeeplinkValid";
import { setModalChild, setModalState } from "../../state/actions/modalAction";
import ErrorPopup from "../../components/ErrorPopup/ErrorPopup";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import EventIcon from '@mui/icons-material/Event';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { localeMap, maskMap } from "../Register/RegFirstStep/RegFirstStep";
import IdDateInfoPopup from "../../components/IdDateInfoPopup/IdDateInfoPopup";
import HelpCircleIcon from "../../components/HelpCircleIcon/HelpCircleIcon";
import { log } from "console";
import heLocale from "date-fns/locale/he";
import arLocale from "date-fns/locale/ar";
export const waitimgTimeToSendAgainInSECONDS = 60
const email_regex = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
const israel_phone_regex = /^05\d([-]{0,1})\d{7}$/;
export const waitimgTimeToSendAgaininMiliSeconds = waitimgTimeToSendAgainInSECONDS * 1000;
const Login = (props: { match: any; history: any }) => {
  const { width } = useWindowDimensions();
  const { isEnteredFromToShowFile, isValidAndNotUser, issueDate } = useSelector((state: any) => state.UserReducer);
  const [enteredFromToShow, setEnteredFromToShow] = useState(sessionStorage.getItem("isValidAndNotUser") == 'true' ? true : false)
  const [docNum, setDocNum] = useState<string | null>("");
  const [loading, setLoading] = useState(true);
  const [dateValue, setDateValue] = useState<any>("");
  const [open, setOpen] = useState<boolean>(false);
  // const [isValidLink, setIsValidLink] = useState<boolean | null>(false)
  const isMobile = (width < screenSzie.phone);
  const [locale, setLocale] = useState<keyof typeof maskMap>("he");
  const [dateValueBlured, setDateBlured] = useState({
    status: false,
    count: 0,
  });
  const openIdDateInfoPopup = () => {
    dispatch(setModalState(true));
    dispatch(setModalChild(<IdDateInfoPopup size={"m"} />));
  };
  const validate = (values: LoginInitialValues) => {
    const errors: any = {};


    if (!values.enteredIdNumber) {
      errors.enteredIdNumber = t("Login.idNullError");
    } else if (
      !(
        values.enteredIdNumber.length >= 2 && values.enteredIdNumber.length <= 9
      )
    ) {
      errors.enteredIdNumber = t("Login.idLengthError");
    } else if (
      // check for every digit that is a number
      values.enteredIdNumber
        .split("")
        .filter((digit: string) => parseInt(digit) >= 0 && parseInt(digit) <= 9)
        .length !== values.enteredIdNumber.length
    ) {
      errors.enteredIdNumber = t("Login.idLengthError");
    } else if (
      // handle all zeros case
      values.enteredIdNumber
        .split("")
        .filter((digit: string) => parseInt(digit) === 0).length ===
      values.enteredIdNumber.length
    ) {
      errors.enteredIdNumber = t("Login.idLengthError");
    }




    if (!values.phoneNumber && phoneRef.current) {
      errors.phoneNumber = t("Login.phoneNullError");
    } else if (
      !checkValidCellphoneCode(values.phoneNumber.slice(0, 3)) &&
      phoneRef.current
    ) {
      errors.phoneNumber = t("Login.phoneError");
    } else if (
      !values.phoneNumber.match(israel_phone_regex) &&
      phoneRef.current
    ) {
      errors.phoneNumber = t("Login.phoneError");
    }

    if (!values.enteredMail && mailRef) {
      errors.enteredMail = t("Login.mailNullError");
    } else if (!values.enteredMail.match(email_regex) && mailRef) {
      errors.enteredMail = t("Login.mailInvalidError");
    } else if (values.enteredMail.length > 50) {
      errors.enteredMail = t("Login.mailInvalidError");
    }


    return errors;
  };


  const dispatch = useDispatch();

  const sucsess = () => {
    setFormSubmitted(true);
    dispatch(setIsSuspend(false));
    if (setIsSendAgainPossible) {
      let date = new Date()
      date.setSeconds(date.getSeconds() + waitimgTimeToSendAgainInSECONDS);
      dispatch(setIsSendAgainPossibleDate(date))
      dispatch(setIsSendAgainPossible(false))
      setTimeout(() => dispatch(setIsSendAgainPossible(true)), waitimgTimeToSendAgaininMiliSeconds)
    }
  }

  const formik = useFormik({
    initialValues: {
      enteredIdNumber: "",
      enteredMail: "",
      phoneNumber: "",
      issueDate1: "",
    },
    validate,
    onSubmit: async (values: LoginInitialValues) => {
      if (values) {
        setOtpLoading(true);
        if ((sessionStorage.getItem("isEnteredFromToShowFile") != 'true') && !enteredFromToShow) {
          const submitStatus = await OtpSend(
            values.enteredIdNumber, // 053627972
            radioValue === t("Login.radioValue1") ? 1 : 0,
            values.phoneNumber,
            values.enteredMail
          );
          if (otpSendUtil.isSuccess(submitStatus)) {
            localStorage.setItem("userId", values.enteredIdNumber); //set userid to localstorage
            dispatch(setUserId(values.enteredIdNumber));
            setFormSubmitted(true);
            dispatch(setIsSuspend(false));
            if (setIsSendAgainPossible) {
              let date = new Date()
              date.setSeconds(date.getSeconds() + waitimgTimeToSendAgainInSECONDS);
              dispatch(setIsSendAgainPossibleDate(date))
              dispatch(setIsSendAgainPossible(false))
              setTimeout(() => dispatch(setIsSendAgainPossible(true)), waitimgTimeToSendAgaininMiliSeconds)
            }
          } else if (otpSendUtil.isMaxServerRequestsError(submitStatus)) {
            dispatch(setIsSuspend(true));
            setTimeout(() => dispatch(setIsSuspend(false)), suspensionTimeInMiliseconds)
          } else {
            //   console.log(" etSubmitError(true)");
            dispatch(setIsSuspend(false));
            setSubmitError(true);
          }
          setOtpLoading(false);
        }

        else {
          const submitStatus = await deepLinkOTPSend(
            sessionStorage.getItem("requestID") || "",
            values.enteredIdNumber, // 053627972
            radioValue === t("Login.radioValue1") ? 1 : 0,
            values.phoneNumber,
            values.enteredMail,
            issueDate
          );

          if (typeof (submitStatus) == "boolean" && submitStatus) {
            localStorage.setItem("userId", values.enteredIdNumber); //set userid to localstorage
            dispatch(setUserId(values.enteredIdNumber));
            setFormSubmitted(true);
            dispatch(setIsEnteredFromToShowFile(true))
            sessionStorage.setItem("isEnteredFromToShowFile",'true');
            dispatch(setIsSuspend(false));
            if (setIsSendAgainPossible) {
              let date = new Date()
              date.setSeconds(date.getSeconds() + waitimgTimeToSendAgainInSECONDS);
              dispatch(setIsSendAgainPossibleDate(date))
              dispatch(setIsSendAgainPossible(false))
              setTimeout(() => dispatch(setIsSendAgainPossible(true)), waitimgTimeToSendAgaininMiliSeconds)
            }
          } else if (otpSendUtil.isMaxServerRequestsError(submitStatus)) {
            dispatch(setIsSuspend(true));
            setTimeout(() => dispatch(setIsSuspend(false)), suspensionTimeInMiliseconds)
          } else {
            //   console.log(" etSubmitError(true)");
            dispatch(setIsSuspend(false));
            setSubmitError(true);
          }

        }
      }
      setOtpLoading(false);

    }
  });

  const { t, i18n } = useTranslation("common");
  const { isOnline } = useSelector((state: any) => state.UserReducer);
  const [radioValue, setRadioValue] = useState<string>(t("Login.radioValue1"));
  const [isOtpLoading, setOtpLoading] = useState<boolean>(false);
  const [isFormSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [submitError, setSubmitError] = useState<boolean>(false);
  const [clickbtnsub, setClickbtnsub] = useState<boolean>(false);
  const { isSuspend } = useSelector((state: any) => state.UserReducer);
  const [mailRef, setMailRef] = useState<string>("");
  const phoneRef = useRef(null);
  const { match, history } = props;

  const openRegisterPage = () => {
    history.push("/register");
  };

  useDidMountEffect(() => {
    setRadioValue(t("Login.radioValue1"));
    formik.validateForm(); // need to check it out
  }, [i18n.language]);


  const InputFocus = useInputFocus(formik.errors, formik.submitCount, clickbtnsub);
  useEffect(() => {
    if (InputFocus) {
      setClickbtnsub(false);
    }
  }, [InputFocus, clickbtnsub]);

  useEffect(() => {
    isEnteredFromToShowFile && loading && setLoading(false);
  }, []);

  const handleIdBlured = () => {
    setDateBlured((value) => {
      return {
        status: true,
        count: (value.count += 1),
      };
    });
  };
   const localeMap = {
    he: heLocale,
    ar: arLocale,
  };
  

  useEffect(() => {
    function handleKeyDown(e: any) {

      if (e.keyCode == 13) {
        if (isOtpLoading && isFormSubmitted) setFormSubmitted(true);
      }
    }
    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);


  useEffect(() => {
    let goto = match.params.goto;
    if (goto) {
      sessionStorage.setItem("goto", match.params.goto);
      const currentUrl = window.location.href;
      const params = new URLSearchParams(currentUrl.split('?')[1]);
      const qParam = params.get('q');
      let requestID = encodeURIComponent(qParam || "");      
      sessionStorage.setItem("requestID", requestID);
      if(requestID?.length || sessionStorage.getItem("requestID")?.length)
      dispatch(setIsEnteredFromToShowFile(true))
      sessionStorage.setItem("isEnteredFromToShowFile",'true')
      setEnteredFromToShow(true);
      sessionStorage.getItem("isEnteredFromToShowFile")== 'true' ? document.title = t("Login.titleFile") : document.title = t("Login.title");
      const check = async () => {
        CheckDeeplinkValid(requestID || sessionStorage.getItem("requestID") || "").then((res: any) => {
          if ((res == deeplink.validAndUser || res == deeplink.validAndNotUser) && requestID?.length) {
            dispatch(setIsEnteredFromToShowFile(true))
              sessionStorage.setItem("isEnteredFromToShowFile",'true')
            setEnteredFromToShow(true);
            document.title = t("Login.titleFile");
            if (res == deeplink.validAndNotUser) {
              dispatch(setIsValidAndNotUser(true))
              sessionStorage.setItem("isValidAndNotUser",'true')
            }
          }
          else {
            if (res == deeplink.notValid) {
              dispatch(setIsEnteredFromToShowFile(false))
              sessionStorage.setItem("isEnteredFromToShowFile",'false')
              setEnteredFromToShow(false);
              sessionStorage.setItem("goto", "")
              dispatch(setModalState(true));
              dispatch(
                setModalChild(
                  <ErrorPopup size="m" subLabel={t("general.errorExpiredLinkSub")} label={t("general.errorExpiredLink")} center={true} />
                )
              );
            }
            else {
              document.title = t("Login.title");
              dispatch(setIsEnteredFromToShowFile(true))
              sessionStorage.setItem("isEnteredFromToShowFile",'true')

              setEnteredFromToShow(true);
            }
          }
          setLoading(false);
        })
      }
      check()
      history.push("/login");
    } else {
      document.title = (sessionStorage.getItem("isEnteredFromToShowFile") == 'true') ? t("Login.titleFile"): t("Login.title");

    }



    if (isOnline) {
      // fix click on browser back arrow bug when user online
      dispatch(resetUser());
      dispatch(setActiveFund({} as UserFund));
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="login page">
      <div className="content" id="login-main-content">
        <div className="wrap-login-wrap-details">
          <div className="login-wrap-details" id="login-main-wrap-details" role="main">
            {(isOtpLoading || ((enteredFromToShow || isEnteredFromToShowFile) && loading)) ? (
              <CircleLoading loadingLabel={isOtpLoading ? t("Login.codeOneTheWay") : t("general.loading")} />
            ) : isFormSubmitted ? (
              <Otp
                docNum={docNum}
                emailSelected={
                  radioValue === t("Login.radioValue1") ? false : true
                }
                enteredCellphoneNumber={
                  formik.values.phoneNumber
                    ? formik.values.phoneNumber
                    : undefined
                }
                enteredEmail={
                  formik.values.enteredMail
                    ? formik.values.enteredMail
                    : undefined
                }
                setFormSubmitted={setFormSubmitted}
                setRadioValue={setRadioValue}
              />
            ) : (
              <>
                <form onSubmit={formik.handleSubmit}>
                  <div className="mobile-background">
                    <h1 className="big">{((sessionStorage.getItem("isEnteredFromToShowFile") != 'true') && !enteredFromToShow) ? t("Login.title") : t("Login.titleFile")}</h1>
                    <div className="login-confirmation-rep">
                      <div>
                        <CustomInput
                          formik={formik}
                          fullWidth={true}
                          keyString="enteredIdNumber"
                          inputLabel={t("Login.idLabel")}
                          tooltipLabel={t("Login.idTooltipLabel")}
                          withIcon={true}
                          withTooltip={true}
                          maxLength={9}
                          htmlFor={"enteredIdNumber"}
                          ariaDescribedby={"enteredIdNumber"}
                        />
                      </div>
                      { (sessionStorage.getItem("isValidAndNotUser") == 'true' && sessionStorage.getItem("isEnteredFromToShowFile") == 'true') ? <div>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          locale={localeMap[locale]}
                        >
                          <DatePicker
                            label={`${t("RegFirstStep.dateValueLabel")}*`}
                            value={dateValue}
                            okText={t("general.accept")}
                            cancelText={t("general.cancel")}
                            maxDate={new Date()}
                            open={open}
                            onOpen={() => setOpen(true)}
                            onClose={() => setOpen(false)}
                            views={["year", "month", "day"]}
                            inputFormat="dd/MM/yyyy"

                            onChange={(newValue) => {
                              newValue && setDateValue(newValue);
                              console.log(newValue);                              
                              newValue && dispatch(setIssueDate(newValue));

                            }}

                            showToolbar={false}
                            renderInput={(params) => (
                              <div className="CustomInput">
                                <TextField
                                  aria-describedby={"issueDate"}
                                  {...params}
                                  fullWidth
                                  inputProps={{
                                    ...params.inputProps,
                                    style: { textAlign: 'right' },
                                    placeholder: `${new Date().toLocaleDateString('en-gb')}`,
                                    'aria-required': "true",
                                  }}

                                  aria-required="true"
                                  className={`CustomInput date-value-cursor ${(formik.submitCount && !dateValue) ||
                                    (!dateValue &&
                                      dateValueBlured.status &&
                                      dateValueBlured.count > 1)
                                    ? "login-input-error"
                                    : "input-b"
                                    }`}
                                  onBlur={handleIdBlured}
                                  InputProps={{
                                    endAdornment: (
                                      <>
                                        <InputAdornment position="end">
                                          <IconButton edge="end" onClick={(e) => setOpen(true)}>
                                            <EventIcon />
                                          </IconButton>
                                        </InputAdornment>
                                        <InputAdornment position="end">
                                          <IconButton edge="end" onClick={openIdDateInfoPopup}>
                                            <HelpCircleIcon />
                                          </IconButton>
                                        </InputAdornment>
                                      </>
                                    ),
                                  }}
                                />
                                {(formik.submitCount && !dateValue) ||
                                  (!dateValue && dateValueBlured.status && dateValueBlured.count > 1) ? (
                                  <RenderInputError id="issueDate" errorLabel={t("RegFirstStep.dataValueError")} />
                                ) : null}
                              </div>
                            )}
                          />
                        </LocalizationProvider>
                        </div>: null} 
                      <div>
                        {radioValue === t("Login.radioValue1") ? (
                          <CustomInput
                            formik={formik}
                            fullWidth={true}
                            inputRef={phoneRef}
                            keyString="phoneNumber"
                            inputLabel={t("Login.phoneLabel")}
                            tooltipLabel={t("Login.phoneTooltipLabel")}
                            withIcon={true}
                            withTooltip={true}
                            space={true}
                            maxLength={11}
                            htmlFor={"phoneNumber"}
                            ariaDescribedby={"phoneNumber"}
                            isMaskPhone
                          />
                        ) : (
                          <CustomInput
                            formik={formik}
                            fullWidth={true}
                            inputRef={mailRef}
                            keyString="enteredMail"
                            inputLabel={t("Login.mailLabel")}
                            tooltipLabel={t("Login.mailTooltipLabel")}
                            withIcon={true}
                            withTooltip={true}
                            space={true}
                            htmlFor={"enteredMail"}
                            ariaDescribedby={"enteredMail"}
                          />
                        )}
                      </div>
                      <div className="login-confirmation-wrapper">
                        <div className="login-radio-buttons-wrapper">
                          <RadioButtons
                            radioValue={radioValue}
                            setRadioValue={setRadioValue}
                            firstRadioTString="Login.radioValue1"
                            secondRadioTString="Login.radioValue2"
                            title={t("Login.confirmationLabel")}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wrap-buttons">
                    <button id="login-submit-button" className="login-submit-button" type="submit" onClick={() => setClickbtnsub(true)}>
                      {radioValue === t("Login.radioValue1") ? (
                        <span>{t("Login.phoneConformation")}</span>
                      ) : (
                        <span>{t("Login.mailConformation")}</span>
                      )}
                    </button>
                    {submitError || isSuspend ? (
                      <RenderInputError
                        errorLabel={
                          isSuspend
                            ? t("BankAccountVerify.sendAgainError")
                            : t("Login.submitError")
                        }
                        style={{ bottom: 0 }}
                      />
                    ) : null}

                    {(!isEnteredFromToShowFile && !enteredFromToShow) ? <p
                      id="login-element"
                      className="login-final-label"
                      onClick={openRegisterPage}
                      onKeyPress={(event) =>
                        isEnterPress(event) && openRegisterPage()
                      }
                      tabIndex={0}
                    >

                      {t("Login.notSigned")}
                      {isMobile ? <br></br> : null}
                       <NavLink to={'/register'}>{t("Login.signNow")} </NavLink>

                    </p>  : null}

                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </div>

    </div>
  );
};

export default Login;
